import { Card, Col, Row, Table } from "antd";
import SPEED from "../../../assets/images/icons/speed.svg";
import { UNITS } from "../../Common/Constants";
import TripHighlight from "./TripHighlight";
import ChordChart from "./ChordChart";
import { isEmpty } from "lodash";

const SpeedMap = ({ summaryList, tripSummary }) => {
  const summaryCount = summaryList?.length;

  const columns = [
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
      width: "50%",
      render: (_, record, index) => {
        return (
          <div className="left w100">
            <div className="align-center w100">
              <div className={"mode" + index} />
              <div className="mode-text">{record.fieldName}</div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Frequent Speed",
      dataIndex: "speed",
      key: "speed",
      render: (_, record) => {
        return `${record.frequentSpeed} ${UNITS.KM_PER_HR}`;
      },
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      render: (_, record) => {
        return `${record.distance} ${UNITS.KM}`;
      },
    },
  ];

  const overallImageText = () => {
    return (
      <div className="flex-center">
        <div className="mr05 mode-overall" />
        OVERALL
      </div>
    );
  };

  return (
    <Row gutter={[16, 16]} className="mt1">
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={summaryCount > 1 ? 24 : 12}
        xl={summaryCount > 1 ? 24 : 12}
      >
        <Row>
          <Col span={24}>
            <Card
              title={
                <div className="fs14 left">
                  <div className="flex-center">
                    <img src={SPEED} alt="km" className="icon-size mr05" />
                    Mode Speed And Distance of All Trips
                  </div>
                </div>
              }
              className="drive-mode-card"
              actions={
                tripSummary?.overAllSpeedModeData &&
                !isEmpty(tripSummary?.overAllSpeedModeData) && [
                  overallImageText(),
                  `${parseFloat(
                    tripSummary?.overAllSpeedModeData?.frequentSpeed
                  ).toFixed(1)} ${UNITS.KM_PER_HR}`,
                  `${parseFloat(
                    tripSummary?.overAllSpeedModeData?.distance
                  )?.toFixed(1)} ${UNITS.KM}`,
                ]
              }
            >
              <Table
                className="mode-table"
                rowKey={(record) => record.fieldName}
                columns={columns}
                dataSource={tripSummary?.speedModeData}
                pagination={false}
                scroll={{ x: "100%", y: 140 }}
              />
            </Card>
          </Col>
        </Row>
        <Row className="mt075">
          <Col span={24}>
            <TripHighlight
              summaryList={summaryList}
              tripSummary={tripSummary}
            />
          </Col>
        </Row>
      </Col>
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={summaryCount > 1 ? 24 : 12}
        xl={summaryCount > 1 ? 24 : 12}
      >
        <div className="wheel-chart-col">
          <ChordChart summaryList={summaryList} tripSummary={tripSummary} />
        </div>
      </Col>
    </Row>
  );
};

export default SpeedMap;
